import React from 'react'
import ButtonGestionBlock from '../../Includes/Button/ButtonGestionBlock'
import ButtonGestionUnblock from '../../Includes/Button/ButtonGestionUnblock'
import ButtonGestionDisconnect from '../../Includes/Button/ButtonGestionDisconnect'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  BLOCK_USER,
  MODAL_USERS,
  DISCONNECT_USER
} from '../../../Redux/Actions/Users'

const UsersToolbarButtons = () => {
  const dispatch = useDispatch()
  const selected = useSelector(state => state.users.selected)
  const Texte = (action) => {
    const texte = (selected.length > 1)
      ? "les utilisateurs sélectionnés"
      : "l'utilisateur sélectionné"
    switch (action) {
      case 'block':
        return (
          <span>Voulez-vous vraiment <b>bloquer</b> {texte} ?</span>
        )
      case 'unblock':
        return (
          <span>Voulez-vous vraiment <b>débloquer</b> {texte} ?</span>
        )
      case 'disconnect':
        return (
          <span>Voulez-vous vraiment <b>déconnecter</b> {texte} ?</span>
        )
      default:
      break
    }
  }
  return (
    <>
      <ButtonGestionUnblock
        disabled={(selected.length === 0)}
        onClick={() => {
          dispatch(MODAL_USERS(
            true,
            Texte('unblock'),
            () => dispatch(BLOCK_USER(selected, 0))
          ))
        }}
      />
      <ButtonGestionBlock
        disabled={(selected.length === 0)}
        onClick={() => {
          dispatch(MODAL_USERS(
            true,
            Texte('block'),
            () => dispatch(BLOCK_USER(selected, 1))
          ))
        }}
      />
      <ButtonGestionDisconnect
        disabled={(selected.length === 0)}
        onClick={() => {
          dispatch(MODAL_USERS(
            true,
            Texte('disconnect'),
            () => dispatch(DISCONNECT_USER(selected))
          ))
        }}
      />
    </>
  )
}

export default UsersToolbarButtons
